import classNames from "classnames";
import Loading from "../Loading/index";

export const Button = ({
  variant,
  size = "normal",
  isDisabled = false,
  isOutline = false,
  shape = "default",
  isLoading = false,
  isLink = false,
  loadingType = "spinner",
  loadingText = "",
  type = "button",
  children,
  className,
  animatedIcon = false,
  ...props
}) => {
  const classes = classNames(
    "btn",
    className,
    { [`btn-${variant}`]: variant },
    { "btn-link": isLink },
    { "animated-icon": animatedIcon },
    { "pointer-events-none opacity-80": isLoading }
  );

  return (
    <button type={type} disabled={isDisabled} className={classes} {...props}>
      {isLoading && <Loading size="normal" type={loadingType} />}
      {isLoading ? loadingText : children}
    </button>
  );
};
